<template>
  <custom-modal-tailwind
    :visible="visible"
    :title="title"
    :ok-text="confirmText"
    :cancel-text="cancelText"
    ok-variant="danger"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <p style="margin: 0; padding: 0; line-height: 1.5;">{{ message }}</p>
  </custom-modal-tailwind>
</template>

<script>
import CustomModalTailwind from '@/@core/components/CustomModalTailwind/CustomModalTailwind.vue'

export default {
  name: 'ConfirmationModal',
  components: {
    CustomModalTailwind
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Confirmar'
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
